import { render, staticRenderFns } from "./OrderCheckout.vue?vue&type=template&id=6024c00b&scoped=true&"
import script from "./OrderCheckout.vue?vue&type=script&lang=js&"
export * from "./OrderCheckout.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheckout.vue?vue&type=style&index=0&id=6024c00b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024c00b",
  null
  
)

export default component.exports